module.exports = __webpack_public_path__ + "a10e3c4af774d5e3152ef633985e42c2.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/icons/icon-engagementrate.png
// module id = 3214
// module chunks = 69